import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';

import { getPageDataSelector } from '../../selectors/page';
import RouteLink from '../_base/RouteLink';
import Image from '../_base/Image';

import { withCssUnit } from '../styleguide/utils';

const DEFAULT_BOX_SHADOW = 'box-shadow: 0 0 20px rgba(0,0,0,.2);';
const DEFAULT_BORDER_RADIUS = 0;
const DEFAULT_BORDER = '2px solid #f0f0f0';

const StyledWrapper = styled.section`
  display: flex;
  margin-top: 10px;
  margin-bottom: 20px;
  overflow: auto;
  width: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
  flex-wrap: nowrap;
  white-space: nowrap;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0;
    margin-bottom: 30px;
  }
`;

const StyledItem = styled(RouteLink)`
  && {
    display: flex;
    align-items: center;
    padding: 7px 20px;
    text-decoration: none;
    font-size: 1em;
    font-weight: 600;
    text-align: center;
    border: ${({ theme }) =>
      _.get(theme, 'productCard.border', DEFAULT_BORDER)};
    border-radius: ${({ theme }) =>
      _.get(theme, 'borderRadius', DEFAULT_BORDER_RADIUS)};
    margin-right: 10px;
    margin-bottom: 10px;
    transition: all 0.4s;
    width: auto;
    &:hover {
      z-index: 2;
      box-shadow: ${({ theme }) =>
        _.get(theme, 'productCard.hover.boxShadow', DEFAULT_BOX_SHADOW)};
    }
    @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
      display: flex;
      width: auto;
      font-size: 1.1em;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

const SubCategoryIcon = styled(Image)`
  && {
    width: 28px;
    height: auto;
    display: block;
    margin-right: 2px;
  }
`;

const SubCategories = ({ category = {} }) => {
  const { childCategories } = category;
  if (!_.isEmpty(childCategories)) {
    return (
      <StyledWrapper>
        {_.map(childCategories, item => {
          return (
            <StyledItem
              key={'subcategory-' + item.urlName}
              href={item.externalUrl}
              route="category"
              params={{ id: item.urlName }}
              target={item.openInNewWindow ? '_blank' : ''}
            >
              {item.mainPhoto && (
                <SubCategoryIcon
                  {...item.mainPhoto}
                  size="20x28.jpg"
                  lazyload={false}
                />
              )}
              {item.name}
            </StyledItem>
          );
        })}
      </StyledWrapper>
    );
  }
  return null;
};

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const mapStateToProps = (state, props) => {
    return {
      category: _.get(getPageData(state, props), 'data')
    };
  };
  return mapStateToProps;
};

const SubCategoriesConnected = connect(makeMapStateToProps)(SubCategories);

export default SubCategoriesConnected;
